import { c as _c } from "react/compiler-runtime";
import DeleteForever from "@mui/icons-material/DeleteForever";
import { Button, Dialog, Stack } from "@mui/material";
import type { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import type { useFormik } from "formik";
import React from "react";
import { useI18nContext } from "#/shared/hooks";
export type EditModalProps = DialogProps & {
  title: string;
  summary: string;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
  formik: ReturnType<typeof useFormik<any>>;
  children: React.ReactNode;
};
export const EditFormModal: React.FC<EditModalProps> = t0 => {
  const $ = _c(54);
  let children;
  let formik;
  let isDeleting;
  let onClose;
  let onDelete;
  let props;
  let summary;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      summary,
      isDeleting,
      onClose,
      onDelete,
      formik,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = formik;
    $[3] = isDeleting;
    $[4] = onClose;
    $[5] = onDelete;
    $[6] = props;
    $[7] = summary;
    $[8] = title;
  } else {
    children = $[1];
    formik = $[2];
    isDeleting = $[3];
    onClose = $[4];
    onDelete = $[5];
    props = $[6];
    summary = $[7];
    title = $[8];
  }
  const {
    LL
  } = useI18nContext();
  const t1 = formik.handleSubmit;
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      textTransform: "capitalize"
    };
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== title) {
    t3 = <DialogTitle sx={t2}>{title}</DialogTitle>;
    $[10] = title;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== summary) {
    t4 = <DialogContentText>{summary}</DialogContentText>;
    $[12] = summary;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mt: 2
    };
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== children) {
    t6 = <Stack spacing={2} sx={t5}>{children}</Stack>;
    $[15] = children;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <DialogContent>{t4}{t6}</DialogContent>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== LL) {
    t8 = LL.DELETE_THIS_PROJECT();
    $[20] = LL;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DeleteForever />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      mr: "auto"
    };
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== LL) {
    t11 = LL.DELETE();
    $[24] = LL;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== isDeleting || $[27] !== onDelete || $[28] !== t11 || $[29] !== t8) {
    t12 = <Button title={t8} color="error" endIcon={t9} loading={isDeleting} loadingPosition="end" onClick={onDelete} sx={t10}>{t11}</Button>;
    $[26] = isDeleting;
    $[27] = onDelete;
    $[28] = t11;
    $[29] = t8;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== LL) {
    t13 = LL.CANCEL();
    $[31] = LL;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== onClose || $[34] !== t13) {
    t14 = <Button onClick={onClose}>{t13}</Button>;
    $[33] = onClose;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  const t15 = formik.isSubmitting;
  let t16;
  if ($[36] !== LL) {
    t16 = LL.UPDATE();
    $[36] = LL;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== formik.isSubmitting || $[39] !== t16) {
    t17 = <Button type="submit" loading={t15}>{t16}</Button>;
    $[38] = formik.isSubmitting;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t12 || $[42] !== t14 || $[43] !== t17) {
    t18 = <DialogActions>{t12}{t14}{t17}</DialogActions>;
    $[41] = t12;
    $[42] = t14;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== formik.handleSubmit || $[46] !== t18 || $[47] !== t3 || $[48] !== t7) {
    t19 = <form onSubmit={t1}>{t3}{t7}{t18}</form>;
    $[45] = formik.handleSubmit;
    $[46] = t18;
    $[47] = t3;
    $[48] = t7;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== onClose || $[51] !== props || $[52] !== t19) {
    t20 = <Dialog {...props} onClose={onClose}>{t19}</Dialog>;
    $[50] = onClose;
    $[51] = props;
    $[52] = t19;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  return t20;
};